import { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'motion/react';
import Logo from './Logo';
import AnimatedGradientLayer from './AnimatedGradientLayer';

const OrientationLock = () => {
  const [isPortrait, setIsPortrait] = useState(false);

  useEffect(() => {
    const checkOrientation = () => {
      // Detectar si está en modo vertical (portrait)
      const portrait = window.innerHeight > window.innerWidth;
      setIsPortrait(portrait);
    };

    // Comprobar orientación inicial
    checkOrientation();

    // Escuchar cambios de orientación y resize
    window.addEventListener('resize', checkOrientation);
    window.addEventListener('orientationchange', checkOrientation);

    return () => {
      window.removeEventListener('resize', checkOrientation);
      window.removeEventListener('orientationchange', checkOrientation);
    };
  }, []);

  return (
    <AnimatePresence>
      {isPortrait && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.3 }}
          className="fixed inset-0 z-[9999] bg-[#07182D] flex flex-col items-center justify-center"
        >
          {/* Logo */}
          <Logo className="w-[30rem] h-auto mb-[8rem]" />
          
          {/* Icono de rotación */}
          <motion.div
            animate={{ rotate: [-90, 0, 0, -90] }}
            transition={{
              duration: 3,
              repeat: Infinity,
              ease: "easeInOut",
              times: [0, 0.2, 0.6, 1]
            }}
            className="mb-[6rem]"
          >
            <svg
              width="120"
              height="120"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                x="3"
                y="6"
                width="18"
                height="12"
                rx="2"
                stroke="white"
                strokeWidth="1.5"
                fill="none"
              />
              <path
                d="M12 10L12 7M12 7L10 9M12 7L14 9"
                stroke="#45c1e9"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </motion.div>

          {/* Texto */}
          <div className="text-center px-[4rem]">
            <h2 className="text-white text-[4rem] font-medium mb-[3rem]">
              Rotate Your Device
            </h2>
            <p className="text-white text-[2.5rem] font-light opacity-80">
              Please rotate your device to landscape mode
              <br />
              for the best experience
            </p>
          </div>

          {/* Degradado decorativo */}

          {/*
          <div className="absolute bottom-0 left-0 right-0 h-[20rem] bg-gradient-to-t from-[#45c1e9]/20 to-transparent pointer-events-none" />
          */}
            <AnimatedGradientLayer />
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default OrientationLock;
